import React from 'react'
import SwiperCore, { Pagination, Autoplay } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Banner } from '../../apis/response_types'
import 'swiper/swiper-bundle.min.css'

SwiperCore.use([Pagination, Autoplay])
// https://swiper6.vercel.app

export default function TopSpecialBanner(props: {
  banners: Banner[]
  paginationClass: string
}) {
  return (
    <>
      <Swiper
        loop
        spaceBetween={10}
        autoplay={{ delay: 5000 }}
        pagination={{
          type: 'bullets',
          clickable: true,
          el: `.pagination-${props.paginationClass}`
        }}
      >
        {props.banners.map((b, i) => {
          return (
            <SwiperSlide key={i}>
              <a href={b.url} target="_blank">
                <img src={b.image_url} alt={b.title} />
              </a>
            </SwiperSlide>
          )
        })}
      </Swiper>
      <div
        className={`swiper-pagination pagination-${props.paginationClass}`}
      ></div>
    </>
  )
}
